/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/compose'
export default icon
